module.exports = __webpack_public_path__ + "img/mail.de14894d.svg";